import api from "../https/api"
const checkPhone = async (rule,value) => {
  
  if(!value){
    return Promise.resolve()
  }
  
  if(!/^1[3456789]\d{9}$/.test(value)){
    return Promise.reject('手机号码格式错误')
  }

  return Promise.resolve()
}
const checkMoney = (rule,value) => {

  if(!value){
    return Promise.resolve()
  }
  // if(!/^[1-9][0-9.]{2,9}$/.test(value)){
  //   return Promise.reject('金额格式不正确')
  // }
  const regex =  /^(0|[1-9]\d*)(\.\d{1,2})?$/;
  if (!regex.test(value)) {
      return Promise.reject('金额格式不正确');
  }
  return Promise.resolve()
}
const checkIdCard = (rule,value) => {
  if(!value){
    return Promise.resolve()
  }
  if(!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)){
    return Promise.reject('身份证号码格式错误')
  }
  return Promise.resolve()
}
const checkBankNumber = (rule,value) => {
  if(!value){
    return Promise.resolve()
  }
  if(!/^\d{16,19}$/.test(value)){
    return Promise.reject('银行卡号格式错误')
  }
  return Promise.resolve()
}
const checkCode = (rule,value) => {
  if(!value){
    return Promise.resolve()
  }
  if(!/^[0-9]{6}$/.test(value)){
    return Promise.reject('验证码格式错误')
  }
  //console.log(value)
  return Promise.resolve()
}

const checkCaptcha = async (rule,value) => {

  if(!value){
    return Promise.resolve()
  }
  if(!/^[0-9]{5}$/.test(value)){
    return Promise.reject('验证码格式错误')
  }

  const {data:{code,msg}} = await api.checkCaptcha({code:value})

  if(code === -1){
    return Promise.reject(msg)
  }
  return Promise.resolve()
}
const checkAddress = async (rule,value) => {
  /* if(!value){
    return Promise.resolve()
  }
  if(!/^[^\s]+(?:\s[^\s]+){2,}$/.test(value)){
    return Promise.reject('地址格式错误')
  }
  return Promise.resolve() */

  if (typeof value !== 'string' || value.trim() === '') {
    return Promise.resolve()
  }

  const trimmed = value.trim().toLowerCase();

  const invalidKeywords = [
    '不知道', '不知', '不清楚', '不详', '未知', '没地址',
    '无地址', '没有地址', '暂无', '待定', '随便', '乱填',
    '测试', 'test', 'example', 'xxx', '****', '不要填',
    '未提供', '未填写', '空', '无', 'none', 'n/a', 'na',
    '地址', '详细地址', '请填写', '抵押物'// 防止用户直接复制 label
  ];
  // 1. 检查是否包含无效关键词
  if (invalidKeywords.some(keyword => trimmed.includes(keyword))) {
    return Promise.reject(`请填写真实的详细地址，不要填写“${trimmed}”等无效内容`)
  }
  
  // 2. 长度限制：建议 4 ~ 100 个字符
  if (trimmed.length < 4 || trimmed.length > 100) {
    return Promise.reject('地址格式错误')
  }

  // 3. 必须包含至少一个中文字符（避免纯英文/数字地址）
  if (!/[\u4e00-\u9fa5]/.test(trimmed)) {
    return Promise.reject('地址格式错误')
  }

  // 4. 允许的字符：中文、字母（大小写）、数字、常见地址符号
  // 符号包括：号、栋、单元、室、巷、弄、楼、座、层、-、/、\、.、( )、（）、空格等
  const validPattern = /^[\u4e00-\u9fa5a-zA-Z0-9\s\-\/\\.,()（）号栋单院室楼座层巷弄]+$/.test(trimmed);

  if (!validPattern) {
    return Promise.reject('地址格式错误')
  }

  // 5. 不能全是符号或数字（已有中文判断，此步可选加强）
  // 已由第3步保证，此处可省略

  return Promise.resolve()
}

const checkWorkUnit = async (rule,value) => {
  if(!value || value.trim() === ''){
    return Promise.resolve()
  }
  const val = value.trim().toLowerCase();

  if (val.length < 3 || val.length > 30) {
    return Promise.reject('单位名称3-30个字符');
  }
  const invalidKeywords = [
    '不知道', '不知', '无', '無', '暂无', '暫無', '未填', '未填写',
    'none', 'null', 'n/a', 'na', '未知', '没填', '没有', '沒填', '沒有'
  ];
  if (invalidKeywords.some(keyword => val.includes(keyword))) {
    return Promise.reject(`请填写单位名称，不要填写“${val}”等无效内容`)
  }
  return Promise.resolve()
}

export {
  checkPhone,
  checkMoney,
  checkIdCard,
  checkBankNumber,
  checkCode,
  checkCaptcha,
  checkAddress,
  checkWorkUnit
}